export default "__VITE_ASSET__o5hCl0lO__"